import React from "react";

import { useQuery } from "@apollo/client";

// import moment from "moment";

import valuesQuery from "./values-query";

interface Props {
  metaData: any;
}

function ValueCell(props: Props) {
  const { metaData } = props;
  // console.log("ValueCell", metaData);

  const variables: any = {};
  let searchParams = new URL(metaData.ajaxUrl).searchParams;

  searchParams.forEach(function (value, key) {
    // if (key === "startDate" || key === "endDate") {
    //   // TODO Check the format!
    //   const newValue = moment(value, 'YYYYMMDDTHH:mm:ss').unix();
    //   console.log(key, value, Date.parse(value));
    //   variables[key] = isNaN(newValue) ? value : newValue;
    // } else
    // if (key === "node") {
    //   variables["nodes"] = value;
    // } else {
    variables[key] = value;
    // }
  });

  const { data, error, loading } = useQuery(valuesQuery, {
    variables: variables,
  });
  // console.log("cell meta", metaData);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // console.log("cell data", data);
  return data.values.formattedValue;
  // return (<>{(data.values && data.values[0].data) && JSON.stringify(data.values[0].data[0][1])}</>);
}

export default ValueCell;
